module.exports = __webpack_public_path__ + "static/media/pla_clear_green_stripes_straw2.99018142.png";